const mn = {
  activePlan: "Идэвхтэй багц",
  endDate: "Дуусах огноо",
  upgradePlan: "Багц ахиулах",
  logout: "Гарах",
  expiryDate: "Дуусах огноо",
  add: "Нэмэх",
  vocabulary: "Үгийн сан",
  vocabularyList: "Үгсийн жагсаалт",
  listIsEmpty: "Жагсаалт хоосон байна",
  addNewWord: "Шинэ үг нэмэх",
  close: "Хаах",
  save: "Хадгалах",
  enterWordToSearch: "Хайх үгээ бичнэ үү...",
  wordAlreadyExists: "Энэ үг аль хэдийн нэмэгдсэн байна.",
  filter: "Шүүх...",
  deleteWords: "Сонгогдсон {{count}} үгийг устгах",
  deleteAllWords: "Бүх үгийг устгах",
  inputVocabularyWord: "Шинээр нэмэх үгээ бичнэ үү...",
  deletedSuccessfully: "Амжилттай устгагдлаа",
  noMistakeFound: "Алдаатай үг олдсонгүй",
  noSuggestions: "Санал болгосон үг олдсонгүй",
  addToVocabulary: "Үгийн санд нэмэх",
  spellCheck: "Алдаа шалгуур",
  dictionary: "Болор толь",
  alwaysCheckSpelling: "Зөв бичих дүрэм үргэлж шалгах",
  alwaysCheckSpellingDescription: "Текст бичих явцад алдаа гарвал автоматаар шалгана.",
  refetchSpellcheck: "Алдаа дахин шалгах",
  search: "Хайх",
  copied: "{{copied}}-г хуулж авлаа",
  searchResults: "Хайлтын илэрц",
  searchPlaceholder: "Хайх үгээ бичнэ үү.",
  noInputToSearch: "Хайх үгээ бичнэ үү",
  noSearchResults: "Илэрц олдсонгүй",
  loginSuccessful: "Амжилттай нэвтэрлээ",
  loginFailed: "Нэвтрэхэд алдаа гарлаа",
  loginText1: "Сайн",
  loginText2: "байна",
  loginText3: "уу?",
  loginWithTodu: "Todu-гаар нэвтрэх",
  noActiveSubscription: "Танд идэвхтэй багц байхгүй байна. Багцаа ахиулаарай.",
  sessionExpired: "Өөр төхөөрөмжөөс нэвтэрсэн байна. Дахин нэвтэрнэ үү.",
};

export default mn;
